var $f4095fb5a72adbe6$exports = {};
$f4095fb5a72adbe6$exports = {
  "close": "Cerrar",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " notificaci\xF3n");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " notificaciones");
      }
    }), ".");
  }
};
export { $f4095fb5a72adbe6$exports as default };